





































































































































import {
  computed,
  defineComponent,
  useContext,
  useFetch,
  useMeta,
  useRoute,
} from '@nuxtjs/composition-api'
import { BreadcrumbItem, useBreadcrumb } from '~/composables/ui/useBreadcrumb'
import { useContent } from '~/composables/useContent'
import {
  SchemaScript,
  useBreadcrumbsSchemaScript,
  useStoreSchemaScript,
} from '~/composables/useSchemaScript'
import { useStoreDetail } from '~/composables/useStoreDetail'
import { STORE_MAKERS } from '~/composables/useStoreList'
import { getTodayRegularTime, localeWeekDay } from '~/lib/utilities/datetime'
import { Store } from '~/types/store'

export default defineComponent({
  name: 'PagesStoreDetail',

  setup() {
    const { breadcrumbs, setBreadcrumbs } = useBreadcrumb()
    const { breadcrumbsSchemaScript, setBreadcrumbsSchemaScript } =
      useBreadcrumbsSchemaScript()
    const { storeSchemaScript, setStoreSchemaScript } = useStoreSchemaScript()
    const {
      app: { $utils },
      i18n,
      $config,
    } = useContext()
    const { loading, store, socialLinks, getStoreByName, getSocialLinks } =
      useStoreDetail()
    const route = useRoute()
    const { setPageMeta } = useContent()
    useFetch(async () => {
      await getStoreByName(route.value.params.slug)
      if (!store.value) return

      setBreadcrumbs([
        {
          to: {
            name: 'store-lister',
          },
          label: `${i18n.t('store.branches')}`,
        },
        {
          label: store.value.name,
        },
      ])
      setBreadcrumbsSchemaScript(breadcrumbs.value!)
      setStoreSchemaScript(store.value as Store)
      //await getSocialLinks(store.value.id)

      setPageMeta({
        type: 'business.business',
        title: store.value.name,
        img: store.value.image,
      })

    })

    const center = computed(() => {
      const location = store.value?.location
      return {
        lat: location?.lat ?? 0,
        lng: location?.lng ?? 0,
      }
    })

    const todayClosingTime = computed(() => {
      const regularTimes = store.value?.openingTimes?.regularTimes
      if (!regularTimes?.length) return '-'

      return getTodayRegularTime(regularTimes)?.closeTime ?? ''
    })

    useMeta(() => {
      const scriptArr: SchemaScript[] = []
      if (breadcrumbsSchemaScript.value) {
        scriptArr.push(breadcrumbsSchemaScript.value)
      }
      if (storeSchemaScript.value) {
        scriptArr.push(storeSchemaScript.value)
      }

      return scriptArr.length
        ? {
            script: scriptArr,
          }
        : {}
    })

    useMeta(() => {
      if (!store.value) return {}

      const businessMetas: {
        hid?: string
        property: string
        content: string
      }[] = []
      store.value?.openingTimes?.regularTimes.forEach((regularTime) => {
        const weekDay = localeWeekDay(regularTime.day, 'EN')
        businessMetas.push(
          ...[
            {
              property: 'business:hours:day',
              content: weekDay,
            },
            {
              hid: `${weekDay}-start`,
              property: 'business:hours:start',
              content: regularTime.openTime ?? '',
            },
            {
              hid: `${weekDay}-end`,
              property: 'business:hours:end',
              content: regularTime.closeTime ?? '',
            },
          ]
        )
      })

      return {
        meta: [
          {
            property: 'business:contact_data:street_address',
            content: $utils.streetAddr(store.value),
          },
          {
            property: 'business:contact_data:locality',
            content: store.value.city,
          },
          {
            property: 'business:contact_data:postal_code',
            content: store.value.postalCode,
          },
          {
            property: 'business:contact_data:country_name',
            content: store.value.countryCode,
          },
          {
            property: 'business:contact_data:phone_number',
            content: store.value.phoneNumber,
          },
          {
            property: 'business:contact_data:email',
            content: store.value.email,
          },
          {
            property: 'business:contact_data:website',
            content: $config.DOMAIN,
          },
          {
            property: 'place:location:latitudee',
            content: store.value.location?.lat,
          },
          {
            property: 'place:location:longitude',
            content: store.value.location?.lng,
          },
          ...businessMetas,
        ],
      }
    })

    return {
      useFetch,
      loading,
      store,
      socialLinks,
      STORE_MAKERS,
      center,
      todayClosingTime,
    }
  },

  head: {},
})
